import { Pipe, PipeTransform } from '@angular/core';
import { isNull } from 'util';

@Pipe({
  name: 'rango'
})
export class RangoPipe implements PipeTransform {

  transform(value: any, maximo: number): any {
    if(isNull(value) || value.length == 0) return []
    if(value.length <= maximo){
      return value
    }else{
      let rango = []
      for(let i=0 ; i < maximo; i++){
        rango.push(value[i])
      }
      return rango
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/rango.pipe.ts